import { WindowLocation } from '@gatsbyjs/reach-router'
import { useContext } from 'react'

import { LocationContext } from '../context'

export const useLocationContext = (): WindowLocation | null => {
  const { location } = useContext(LocationContext)
  return location
}
